<template>
  <div></div>
</template>
<script>
import { mapGetters } from 'vuex'
import FN from '@/utility/fn.js'
import PS from 'pubsub-js'
import '@/fuse/fuse.sdk'
export default {
  data () {
    return {
      ifram: this.$store.state.SDKComponent.iframe
    }
  },
  computed: {
    ...mapGetters(['SDKComponentMessage'])
  },
  methods: {
    init (token, data) {
      FN.log('CP【初始化】传入的值=================>>>>>>', data)
      // 请求融合初始化接口
      window.MJFUSESDK.init().then((res) => {
        if (res.code === 0) {
          // 存储 融合接口初始化返回信息
          FN.saveSession('FUSE_INIT_INFO', res.data || {})
          FN.saveLocal('FUSE_INIT_INFO', res.data || {})
          window.FUSE_INIT_INFO = res.data || {}
          setTimeout(() => {
            if (FN.getSession('FUSE_INIT_INFO') !== '{}' && FN.getSession('FUSE_INIT_INFO').init_notice !== undefined) {
              // 调用融合初始化的公告栏
              this.$store.dispatch('SET_SDK_COMPONENT_NOTICE', 'fuseNotice')
            }
          })
          // 执行渠道sdk.use.js
          window.FUSESDKAPI.init({
            token,
            data,
            callback: (data = {}) => {
              if (FN.getSession('SDK_INIT_INFO').init_notice !== '') {
                // 调用SDK初始化的公告栏
                // this.$store.dispatch('SET_SDK_COMPONENT_SDKNOTICE', 'sdkNotice')
                PS.publish(token, data)
              } else {
                PS.publish(token, data)
              }
              this.$store.dispatch('SET_SDK_COMPONENT_MESSAGE', '')
            }
          })
        }
      })
    },
    isLandscape (data) {
      // 初始化进来是竖屏状态
      if (data.isLandscape === true) {
        this.$store.dispatch('SET_SDK_ISLANDSCAPE', data.isLandscape)
        this.$store.dispatch('SET_SDK_COMPONENT_SCREEN', {name: 'screenc', msg: '请横屏体验效果更佳'})
      } else {
        this.$store.dispatch('SET_SDK_ISLANDSCAPE', data.isLandscape)
        this.$store.dispatch('SET_SDK_COMPONENT_SCREEN', '')
      }
      let orientationChange = (params) => {
        switch (window.orientation) {
          case 0:
            // 当前是竖屏
            if (screen.width < screen.height) {
              if (params.isLandscape === true) {
                this.$store.dispatch('SET_SDK_COMPONENT_SCREEN', {name: 'screenc', msg: '请竖屏体验效果更佳'})
              } else {
                this.$store.dispatch('SET_SDK_COMPONENT_SCREEN', '')
              }
            } else {
              // 当前是横屏
              if (params.isLandscape === true) {
                this.$store.dispatch('SET_SDK_COMPONENT_SCREEN', '')
              } else {
                this.$store.dispatch('SET_SDK_COMPONENT_SCREEN', {name: 'screenc', msg: '请竖屏体验效果更佳'})
              }
            }
            break;
          case -90:
            // 当前是竖屏
            if (screen.width < screen.height) {
              if (params.isLandscape === true) {
                this.$store.dispatch('SET_SDK_COMPONENT_SCREEN', {name: 'screenc', msg: '请竖屏体验效果更佳'})
              } else {
                this.$store.dispatch('SET_SDK_COMPONENT_SCREEN', '')
              }
            } else {
              // 当前是横屏
              if (params.isLandscape === true) {
                this.$store.dispatch('SET_SDK_COMPONENT_SCREEN', '')
              } else {
                this.$store.dispatch('SET_SDK_COMPONENT_SCREEN', {name: 'screenc', msg: '请竖屏体验效果更佳'})
              }
            }

            break;
          case 90:
            // 当前是竖屏
            if (screen.width < screen.height) {
              if (params.isLandscape === true) {
                this.$store.dispatch('SET_SDK_COMPONENT_SCREEN', {name: 'screenc', msg: '请竖屏体验效果更佳'})
              } else {
                this.$store.dispatch('SET_SDK_COMPONENT_SCREEN', '')
              }
            } else {
              // 当前是横屏
              if (params.isLandscape === true) {
                this.$store.dispatch('SET_SDK_COMPONENT_SCREEN', '')
              } else {
                this.$store.dispatch('SET_SDK_COMPONENT_SCREEN', {name: 'screenc', msg: '请竖屏体验效果更佳'})
              }
            }
            break;
          case 180:
            // 当前是竖屏
            if (screen.width < screen.height) {
              if (params.isLandscape === true) {
                this.$store.dispatch('SET_SDK_COMPONENT_SCREEN', {name: 'screenc', msg: '请竖屏体验效果更佳'})
              } else {
                this.$store.dispatch('SET_SDK_COMPONENT_SCREEN', '')
              }
            } else {
              // 当前是横屏
              if (params.isLandscape === true) {
                this.$store.dispatch('SET_SDK_COMPONENT_SCREEN', '')
              } else {
                this.$store.dispatch('SET_SDK_COMPONENT_SCREEN', {name: 'screenc', msg: '请竖屏体验效果更佳'})
              }
            }
            break;
        }
      }
      window.addEventListener('orientationchange', function() {
        orientationChange(data)
        window.onorientationchange = orientationChange(data)
      })
      orientationChange(data)
    }
  },
  mounted () {
    this.init(this.SDKComponentMessage.token, this.SDKComponentMessage.params) // 调用初始化方法
    // this.isLandscape(this.SDKComponentMessage.params) // 调用横竖屏判断
  }
}
</script>
